module.exports = __webpack_public_path__ + "img/ic_edit.31c1615b.svg";